import Splide from '@splidejs/splide';
import Alpine from 'alpinejs'
import collapse from '@alpinejs/collapse'
import './basketProduct';

// Initialise alpine
Alpine.plugin(collapse)
Alpine.start()


document.addEventListener('DOMContentLoaded', () => {
    var cartItems = JSON.parse(localStorage.getItem("cartProducts"));
    var totalProducts = document.getElementById('total-products');
    if (cartItems != null && cartItems.length > 0) {
        totalProducts.style.display = 'flex';
        totalProducts.innerText = cartItems.length;
    } else {
        totalProducts.style.display = 'none';
    }

    if(document.querySelector('.splide') != undefined){
        var splide = new Splide( '.splide', {
            type: 'loop',
            perPage: 4,
            focus  : 0,
            omitEnd: true,
            gap: 30,
            mediaQuery: 'min',
            breakpoints: {
                200: {
                    perPage: 1,
                },
                640: {
                    perPage: 2,
                },
                900: {
                    perPage: 3,
                },
                1340: {
                    destroy: true,
                },
          }            
          } );
          
          splide.mount();
    }

    // if(document.getElementById('empty-localstorage')){
    //     localStorage.clear();
    // }
});


